import { axios } from './axios';
import { MappedFulfillment } from '../component/Claim/types';

export const createProductReturn = async (
  fulfillmentId: string,
  productsForFulfillment: MappedFulfillment[],
  returnReason: string
) => {
  return await axios.post('returns', {
    fulfillment_id: fulfillmentId,
    product_codes: productsForFulfillment.map((product) => product.code),
    return_reason: returnReason,
    pet_ids: productsForFulfillment.map((product) => product.pet_id).filter((id) => id !== null),
  });
};
